export default function (state = false, action) {
  switch (action.type) {
    case "IS_ADMIN":
      return action.payload;
      break;
    default:
      return state;
  }
}
